import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function () {
  gsap.registerPlugin(ScrollTrigger);

  let mm = gsap.matchMedia();

  mm.add(
    {
      isDesktop: "(min-width: 1024px)",
      reduceMotion: "(prefers-reduced-motion: reduce)"
    },
    (context) => {
      const { isDesktop, reduceMotion } = context.conditions;

      if (!isDesktop) return;

      animationDesktop(reduceMotion);
    }
  );
}

function animationDesktop(reduceMotion) {
  const svgAccompagner = document.querySelector('#svg-accompagner');

  if (!svgAccompagner) {
    return;
  }

  const accompagnerTrigger = document.querySelector('#accompagner-trigger');
  const accompagnerPin = document.querySelector('#accompagner-pin');
  const accompagnerSections = document.querySelectorAll('.accompagner-section');

  /* SVG elments */
  const continuiteCercleExterieur = document.querySelector('#continuite-cercle-exterieur');
  const continuiteCercleInterieur = document.querySelector('#continuite-cercle-interieur');

  const securiteLigne = document.querySelector('#securite-ligne');
  const securiteTexte = document.querySelector('#securite-texte');
  const securiteShape = document.querySelector('#securite-shape');

  const accessibiliteLigne = document.querySelector('#accessibilite-ligne');
  const accessibiliteTexte = document.querySelector('#accessibilite-texte');
  const accessibiliteShape = document.querySelector('#accessibilite-shape');

  const performanceLigne = document.querySelector('#performance-ligne');
  const performanceTexte = document.querySelector('#performance-texte');
  const performanceShape = document.querySelector('#performance-shape');

  const conformiteLigne = document.querySelector('#conformite-ligne');
  const conformiteTexte = document.querySelector('#conformite-texte');
  const conformiteShape = document.querySelector('#conformite-shape');

  const evolutionLigne = document.querySelector('#evolution-ligne');
  const evolutionTexte = document.querySelector('#evolution-texte');
  const evolutionShape = document.querySelector('#evolution-shape');

  const cercleFinal = document.querySelector('#cercle-final');

  if(reduceMotion) {
    gsap.set([continuiteCercleExterieur, continuiteCercleInterieur, cercleFinal], {
      strokeDashoffset: 0
    });
  } else {
    /* Cercle animations */
    gsap.to(continuiteCercleExterieur, {
      strokeDashoffset: -300,
      repeat: -1,
      duration: 10,
      ease: 'none'
    });

    gsap.to(continuiteCercleInterieur, {
      strokeDashoffset: 300,
      repeat: -1,
      duration: 10,
      ease: 'none'
    });

    gsap.to(cercleFinal, {
      strokeDashoffset: -300,
      repeat: -1,
      duration: 10,
      ease: 'none'
    });
  }


  gsap.set(svgAccompagner, { autoAlpha: 0 });

  ScrollTrigger.create({
    trigger: accompagnerTrigger,
    pin: accompagnerPin,
    start: 'top top',
    end: 'bottom bottom',
    scrub: 1,
    markers: false
  });

  /* Shapes */
  const tlsecuriteShape = gsap.timeline({
    repeat: -1,
    yoyo: true,
    ease: "power1.inOut",
  });

  const tlAccessibiliteShape = gsap.timeline({
    repeat: -1,
    yoyo: true,
    ease: "power1.inOut",
  });

  const tlPerformance = gsap.timeline({
    repeat: -1,
    yoyo: true,
    ease: "power1.inOut",
  });

  const tlConformiteShape = gsap.timeline({
    repeat: -1,
    yoyo: true,
    ease: "power1.inOut",
  });

  const tlEvolutionShape = gsap.timeline({
    repeat: -1,
    yoyo: true,
    ease: "power1.inOut",
  });

  tlsecuriteShape.to(securiteShape, { duration: 2.5, y: -5 });
  tlAccessibiliteShape.to(accessibiliteShape, { duration: 2.4, y: -5, x : 1 });
  tlPerformance.to(performanceShape, { duration: 2.7, y: 5, x : -1 });
  tlConformiteShape.to(conformiteShape, { duration: 3, y: -5, });
  tlEvolutionShape.to(evolutionShape, { duration: 2.2, y: 4, x : -1 });

  /* step 1*/
  let tlStep1 = gsap.timeline({
    paused: true
  });
  tlStep1.to(svgAccompagner, { duration: 1, autoAlpha: 1 });

  /* step 2*/
  let tlStep2 = gsap.timeline({
    paused: true
  });
  tlStep2
    .to(securiteLigne, { duration: 0.3, autoAlpha: 1 })
    .to(securiteShape, { duration: 0.3, autoAlpha: 1 })
    .to(securiteTexte, { duration: 0.3, autoAlpha: 1 }, '<');

  /* step 3*/
  let tlStep3 = gsap.timeline({
    paused: true
  });
  tlStep3
    .to(accessibiliteLigne, { duration: 0.3, autoAlpha: 1 })
    .to(accessibiliteShape, { duration: 0.3, autoAlpha: 1 })
    .to(accessibiliteTexte, { duration: 0.3, autoAlpha: 1 }, '<');

  /* step 4*/
  let tlStep4 = gsap.timeline({
    paused: true
  });
  tlStep4
    .to(performanceLigne, { duration: 0.3, autoAlpha: 1 })
    .to(performanceShape, { duration: 0.3, autoAlpha: 1 })
    .to(performanceTexte, { duration: 0.3, autoAlpha: 1 }, '<');

  /* step 5*/
  let tlStep5 = gsap.timeline({
    paused: true
  });
  tlStep5
    .to(conformiteLigne, { duration: 0.3, autoAlpha: 1 })
    .to(conformiteShape, { duration: 0.3, autoAlpha: 1 })
    .to(conformiteTexte, { duration: 0.3, autoAlpha: 1 }, '<');

  /* step 6*/
  let tlStep6 = gsap.timeline({
    paused: true
  });
  tlStep6
    .to(evolutionLigne, { duration: 0.3, autoAlpha: 1 })
    .to(evolutionShape, { duration: 0.3, autoAlpha: 1 })
    .to(evolutionTexte, { duration: 0.3, autoAlpha: 1 }, '<')
    .to(cercleFinal, { duration: 0.3, autoAlpha: 1 }, '<');

  accompagnerSections.forEach((section, i) => {
    ScrollTrigger.create({
      trigger: section,
      start: 'center center+=20%',
      end: 'bottom bottom',
      markers: false,
      onEnter: () => {

        if (i === 0) {
          tlStep1.play();
        } else if (i === 1) {
          tlStep2.play();
        } else if (i === 2) {
          tlStep3.play();
        } else if (i === 3) {
          tlStep4.play();
        } else if (i === 4) {
          tlStep5.play();
        } else if (i === 5) {
          tlStep6.play();
        }
      },
      onLeaveBack: () => {

        if (i === 0) {
          tlStep1.reverse();
        } else if (i === 1) {
          tlStep2.reverse();
        } else if (i === 2) {
          tlStep3.reverse();
        } else if (i === 3) {
          tlStep4.reverse();
        } else if (i === 4) {
          tlStep5.reverse();
        } else if (i === 5) {
          tlStep6.reverse();
        }
      }
    });
  });
}
